import axios from 'axios'

export default {
  methods: {
    trackServerSide (id, eventType, payload) {
      // server side tracking
      let trackingUrl = 'https://vb9jsb6kai.execute-api.us-east-1.amazonaws.com/Prod/analytics'
      let requestPayload = {
        email: id,
        eventType,
        payload
      }
      console.log(requestPayload)
      axios
        .post(trackingUrl, requestPayload)
        .then(res => {
          console.log(res)
        })
        .catch(err => {
          console.log(err)
        })
    },
    page () {

    },
    identify () {

    },
    alias () {

    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/AnalyticsMixin.js